import { createSlice } from "@reduxjs/toolkit"
import {
  getAllOrders,
  getOrderDetails,
  syncOrderWithPos,
  updateOrderStatus,
  syncOrderWithSalasa,
} from "store/actions/orderAction"

const initialState = {
  loading: true,
  isLoading: false,
  itemsPerPage: 10,
  totalPages: null,
  isUpdating: false,
  currentPage: 1,
  orders: [],
  orderDetails: {},
}

const usersSlice = createSlice({
  name: "orders",
  initialState,
  reducers: {
    setItemsPerPage: (state, action) => {
      state.itemsPerPage = action.payload
    },
    // Remove a specific order from the current list by its id
    removeOrderFromList: (state, action) => {
      const idToRemove = action.payload
      state.orders = state.orders.filter(item => item._id !== idToRemove)
    },
    // Mark order as sent to Salasa by id
    markOrderSentToSalasa: (state, action) => {
      const orderId = action.payload
      state.orders = state.orders.map(item =>
        item._id === orderId ? { ...item, sentToSalasaFlag: true } : item
      )
    },
  },
  extraReducers: builder => {
    // GET ALL ORDERS
    builder
      .addCase(getAllOrders.pending, state => {
        state.loading = true
      })
      .addCase(getAllOrders.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          const { totalCount, totalPages, currentPage } = action.payload
          state.orders = data
          state.totalCount = totalCount
          state.totalPages = totalPages
          state.currentPage = currentPage
        }
      })
      .addCase(getAllOrders.rejected, (state, action) => {
        state.loading = false
      })

    // GET ORDER DETAILS
    builder
      .addCase(getOrderDetails.pending, state => {
        state.loading = true
      })
      .addCase(getOrderDetails.fulfilled, (state, action) => {
        state.loading = false
        const { status, data } = action.payload
        if (status) {
          state.orderDetails = data
        }
      })
      .addCase(getOrderDetails.rejected, (state, action) => {
        state.loading = false
      })

    // UPDATE BOOKING STATUS
    builder
      .addCase(updateOrderStatus.pending, state => {
        state.isLoading = true
      })
      .addCase(updateOrderStatus.fulfilled, (state, action) => {
        state.isLoading = false
        const { status, data } = action.payload
        if (status) {
          const { id, status } = action.meta.arg
          const hasSnapshot = data && data.orderStatus != null
          state.orders = state.orders.map(item => {
            if (item._id !== id) return item
            if (!hasSnapshot) return { ...item, orderStatus: Number(status) }
            return {
              ...item,
              orderStatus: Number(data.orderStatus),
              posStatus: data.posStatus,
              posReferenceId: data.posReferenceId ?? item.posReferenceId,
              posSettings: { ...(item.posSettings || {}), ...data.posSettings },
            }
          })
        }
      })
      .addCase(updateOrderStatus.rejected, (state, action) => {
        state.isLoading = false
      })

    // Sync Order With POS
    builder
      .addCase(syncOrderWithPos.pending, state => {
        state.isLoading = true
      })
      .addCase(syncOrderWithPos.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(syncOrderWithPos.rejected, (state, action) => {
        state.isLoading = false
      })

    // Sync Order With Salasa
    builder
      .addCase(syncOrderWithSalasa.pending, state => {
        state.isLoading = true
      })
      .addCase(syncOrderWithSalasa.fulfilled, (state, action) => {
        state.isLoading = false
      })
      .addCase(syncOrderWithSalasa.rejected, (state, action) => {
        state.isLoading = false
      })
  },
})

export const { setItemsPerPage, removeOrderFromList, markOrderSentToSalasa } =
  usersSlice.actions

export default usersSlice.reducer
